'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'red';


//////////////////
// WEBPACK FOOTER
// ../~/react-color-picker/lib/defaultColor.js
// module id = 600
// module chunks = 2